(ns ballot-scout-v2-frontend.widget.search-results
  (:require
   [ballot-scout-v2-frontend.util :as util]
   [ballot-scout-v2-frontend.widget.i18n :as i18n :refer [tr]]))

(defn location
  [#:mailpiece{:keys [lastscan-city lastscan-state lastscan-ts]}]
  (cond
    (and lastscan-city lastscan-state lastscan-ts)
    [:span.scan-location
     (tr [:it-was-last-scanned-usps]
         lastscan-city
         lastscan-state
         (util/render-date lastscan-ts))]

    (and lastscan-city lastscan-state)
    [:span.scan-location
     (tr [:it-was-last-scanned-in-city-state]
         lastscan-city
         lastscan-state)]))

(defmulti explanation (fn [step _result] step))
(def success-classes ["notification" "is-size-6" "p-3" "is-success"])
(def danger-classes ["notification" "is-size-6" "p-3" "is-danger" "is-light"])

;; TODO: this is a catch-all -- should it exist?
(defmethod explanation :not-tracked
  [_ _]
  [:div {:class success-classes}
   [:p (tr [:not-tracked-explanation])
    (tr [:check-back-soon])]])

(defmethod explanation :not-yet-mailed
  [_ _]
  [:div {:class success-classes}
   [:span (tr [:not-yet-mailed-explanation-2])]])

(defmethod explanation :voter-bound-mailed
  [_ #:ballot{:keys [voter-bound-mailpiece]}]
  [:div {:class success-classes}
   [:span (tr [:voter-bound-mailed-explanation]) [location voter-bound-mailpiece]]])

(defmethod explanation :voter-bound-in-transit
  [_ #:ballot{:keys [voter-bound-mailpiece]}]
  [:div {:class success-classes}
   [:span (tr [:voter-bound-in-transit-explanation]) [location voter-bound-mailpiece]]])

(defmethod explanation :voter-bound-delivered
  [_ #:ballot{:keys [lastevent-ts]}]
  [:div {:class success-classes}
   (when lastevent-ts
     [:span (tr [:voter-bound-delivered-explanation-2] (str (util/format-utc lastevent-ts)))])
   [:span (tr [:vote-instructions])]])

(defmethod explanation :office-bound-mailed
  [_ #:ballot{:keys [office-bound-mailpiece]}]
  [:div {:class success-classes}
   [:span (tr [:office-bound-mailed-explanation])
    [location office-bound-mailpiece]]])

(defmethod explanation :office-bound-in-transit
  [_ #:ballot{:keys [office-bound-mailpiece]}]
  [:div {:class success-classes}
   [:span (tr [:office-bound-in-transit-explanation])
    (when-let [eta (:mailpiece/estimated-delivery-date office-bound-mailpiece)]
      [:span (tr [:they-should-receive-it-by-eod] (util/format-utc (util/date-str-to-date eta)))])
    [location office-bound-mailpiece]]])

(defmethod explanation :office-bound-delivered
  [_ #:ballot{:keys [lastevent-ts]}]
  [:div {:class success-classes}
   [:span
    (if lastevent-ts
      (tr [:office-bound-delivered-explanation-on] (util/format-utc lastevent-ts))
      (tr [:office-bound-delivered-explanation]))]
   [:span (tr [:thanks-for-voting])]])

(defmethod explanation :accepted
  [_ #:ballot{:keys [lastevent-ts]}]
  [:div {:class success-classes}
   [:span (tr [:ballot-accepted-on] (util/format-utc lastevent-ts))]
   [:span (tr [:thanks-for-voting])]])

(defmethod explanation :flagged
  [_ _]
  [:div {:class danger-classes}
   [:span (tr [:issue-with-ballot])]
   [:span (tr [:learn-more-contact-office])]])

(defmethod explanation :return-to-sender
  [_ _]
  [:div {:class danger-classes}
   [:span (tr [:unable-to-deliver-2])]
   [:span (tr [:learn-more-contact-office])]])

(defn last-scan-time
  [#:ballot{:keys [lastevent-ts]}]
  (when lastevent-ts
    [:div {:class "is-size-6 has-text-weight-medium"}
     (tr [:last-updated]) (util/render-date lastevent-ts)]))
